import React from 'react'
import Loadable from 'react-loadable'

import LoginHigherOrder from '../common/loginComponent'
import LoadingComponent from '../common/loadingComponent'


const InstockMonthComponent = Loadable({
  loader: () => import(/*webpackChunkName: 'ch_instock_month'*/'./dashboard'),
  loading: () => <LoadingComponent />
});

const Dashboard = () => {
  return <InstockMonthComponent />
}

export default LoginHigherOrder(Dashboard)